import {Injectable} from '@angular/core';
import {RedirectInfo} from "../../core/model/interface/helper";
import {ProgressDTO} from "../../core/model/interface/progress";
import {StudentRoutes} from "../../core/model/enum/routes.enum";
import {LessonType} from "../../core/model/enum/lessons";


@Injectable({
  providedIn: 'root'
})

export class StudentHelperService {
  public generateLessonsSiblingsRoute(item: RedirectInfo | ProgressDTO): string {
    let lessonSubRoute = StudentRoutes.Lecture;
    switch(item.lessonType) {
      case LessonType.Quiz: {
        lessonSubRoute = StudentRoutes.Quiz;
        break;
      }
      case LessonType.Task: {
        lessonSubRoute = StudentRoutes.Task
        break;
      }
      case LessonType.Text: {
        lessonSubRoute = StudentRoutes.Text
        break;
      }
      case LessonType.Oral: {
        lessonSubRoute = StudentRoutes.Oral
        break;
      }
    }

    return `${lessonSubRoute}/${item.id}`;
  }
}
